<!-- =========================================================================================
    File Name: Explore.vue
    Description: Explore panel to select guided tags
    ----------------------------------------------------------------------------------------
    Item Name: NexSat
    Author: Anand
========================================================================================== -->

<template>
  <div id="stock-view">
    <!-- <pre>{{getFilterType}}</pre>
    <pre>{{deltaShare}}</pre>
    <pre>{{searchModes}}</pre> -->
    <div class="mb-base">
      <div class="flex md:items-end items-center justify-between flex-wrap">
        <div class="flex justify-between items-end flex-grow">
          <p class="lg:inline-flex hidden font-semibold">Apply filters and choose your view</p>

          <div class="flex flex-wrap">
            <!-- ITEM VIEW - GRID/LIST -->
            <div>
              <feather-icon
                icon="GridIcon"
                @click="changeView('item-grid-view')"
                class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'item-grid-view'}"
              />
              <feather-icon
                icon="FilterIcon"
                @click="changeView('item-list-view')"
                class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'item-list-view'}"
              />
              <feather-icon
                icon="DownloadIcon"
                @click="getListForExport"
                class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'item-manage-view'}"
              />
              <feather-icon
                icon="DatabaseIcon"
                @click="addNewData"
                class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'item-manage-view'}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-base">
      <!-- JUMBOTRON -->
      <template v-if="currentItemView === 'item-grid-view'">
        <div class="mb-base">
          <div class="rounded-lg mb-base">
            <vs-input
              placeholder="Search by sku name, brand or category"
              v-model="stockSearchQuery"
              icon-pack="feather"
              icon="icon-search"
              size="large"
              class="w-full no-icon-border mt-6"
              @input="debounceQueryStock"
            />
            <!-- v-debounce:300ms="queryStock" -->
          </div>
          <div class="flex flex-wrap items-center md:justify-between mb-base">
            <div class="flex flex-wrap">
              <span class="lg:inline-flex hidden font-semibold pr-4">Search by</span>
              <vs-chip
                @click="applyFilter(tag)"
                class="cursor-pointer"
                :class="selectedTag(tag)"
                closable
                :close-icon="selectedIcon(tag)"
                v-for="(tag, index) in searchTags"
                :key="index"
              >{{ tag.tag }}</vs-chip>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="currentItemView === 'item-list-view'">
        <div class="mb-base">
          <div class="rounded-lg mb-4">
            <multiselect
              v-model="multiselect.exploreTags"
              id="ajax"
              label="tag"
              track-by="tag"
              placeholder="Type here to filter by competition"
              open-direction="bottom"
              :options="multiselect.tags"
              :multiple="true"
              :searchable="true"
              :loading="multiselect.isLoading"
              :internal-search="true"
              :clear-on-select="true"
              :close-on-select="false"
              :max="5"
              :options-limit="50"
              :limit="5"
              :limit-text="limitText"
              :max-height="600"
              :show-no-results="true"
              :hide-selected="true"
              @search-change="queryTags"
              @input="refresh()"
              class="w-full no-icon-border mt-3"
            >
              <template slot="tag" slot-scope="{ option, remove }">
                <vs-chip
                  transparent
                  @click="remove(option), refresh()"
                  :color="option.type !== 'E' ? '' : 'primary'"
                  type="gradient"
                  v-bind="{closable : option.type !== 'S'}"
                >
                  <vs-avatar
                    :text="option.type !== 'E' ? option.type : ''"
                    icon="icon-eye"
                    icon-pack="feather"
                  />
                  {{ option.tag }}
                </vs-chip>
              </template>
              <template slot="option" slot-scope="props">
                <div class="flex justify-between">
                  <span class="option__title">{{ props.option.tag | ellipsis(50) }}</span>
                  <vs-chip>{{ multiselect.tagTypes[props.option.type] }}</vs-chip>
                </div>
              </template>
              <template slot="clear" slot-scope="props">
                <div
                  class="multiselect__clear"
                  v-if="multiselect.exploreTags.length"
                  @mousedown.prevent.stop="clearAll(props.search)"
                ></div>
              </template>
              <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
            </multiselect>
          </div>
          <div class="flex flex-wrap items-center md:justify-between mb-base">
            <div class="flex flex-wrap">
              <!-- <span class="lg:inline-flex hidden font-semibold pr-4">Filter by</span> -->
              <template>
                  <div class="flex mr-4" v-for="(tag, index) in searchModes" :key="index">
                    <vx-tooltip :text="tag.desc ? tag.desc : 'Market price diff in given range'" v-if="getFilterType === 'overall'">
                      <vs-chip class="mt-2" transparent :color="tag.status ? 'primary' : ''">
                        <vs-avatar icon-pack="feather" icon="icon-percent" />
                        {{tag.tag}}
                      </vs-chip>
                    </vx-tooltip>
                    <vx-tooltip text="Products priced High" v-if="getFilterType === 'overall'">
                      <vs-avatar
                        badge-color="rgb(140, 23, 164)"
                        :badge="getStat(tag, wrtprice ? 'hamp' : 'high')"
                        @click="applyMode(tag, wrtprice ? 'hamp' : 'high')"
                        :color="tag.status && (tag.mode === 'high' || tag.mode === 'hamp') ? 'danger': 'gray'"
                        text="high"
                        icon-pack="feather"
                        icon="icon-trending-up"
                      ></vs-avatar>
                    </vx-tooltip>
                    <vx-tooltip text="Products priced Low" v-if="getFilterType === 'overall'">
                      <vs-avatar
                        badge-color="rgb(140, 23, 164)"
                        :badge="getStat(tag, wrtprice ? 'lamp' : 'low')"
                        @click="applyMode(tag, wrtprice ? 'lamp' : 'low')"
                        :color="tag.status && (tag.mode === 'low' || tag.mode === 'lamp') ? 'success': 'gray'"
                        text="low"
                        icon-pack="feather"
                        icon="icon-trending-down"
                      ></vs-avatar>
                    </vx-tooltip>
                    <vx-tooltip :text="tag.desc ? tag.desc : 'Price distribution'" v-if="getFilterType === 'specific'">
                      <vs-button
                        size="small"
                        @click="applyMode(tag)"
                        :color="tag.status ? 'primary': 'gray'"
                        :disabled="getStat(tag) === 0"
                      >{{tag.label}} {{getStat(tag) > -1 ? '('+getStat(tag)+')' : ''}}</vs-button>
                    </vx-tooltip>
                  </div>
              </template>
            </div>
            <div class="flex flex-wrap" v-if="getFilterType === 'overall'">
              <span class="lg:inline-flex hidden font-semibold pr-4">With respect to the</span>
              <vs-switch color="primary" v-model="wrtprice" @change="refresh()">
                <span slot="on">Avg. Market Price</span>
                <span slot="off">Next Closest Price</span>
              </vs-switch>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="currentItemView === 'item-manage-view'">
        <div class="mt-base">
          <item-manage-view></item-manage-view>
        </div>
      </template>
      <template v-if="showGrid">
        <div class="items-grid-view vx-row match-height">
          <vs-alert
            active="true"
            color="warning"
            class="mb-base m-5"
            icon-pack="feather"
            icon="icon-alert-triangle"
            v-if="!callInProgress && stock.length === 0"
          >
            <p>No data found for the filter criteria used. Kindly adjust the search filter and try again.</p>
          </vs-alert>
          <div
            class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full"
            v-for="(item, index) in stock"
            :key="index"
          >
            <item-grid-view :item="item">
              <!-- SLOT: ACTION BUTTONS -->
              <template slot="action-buttons">
                <div class="flex flex-wrap">
                  <!-- PRIMARY BUTTON : REMOVE -->
                  <div
                    class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                    @click="removeItemFromWishList(item)"
                  >
                    <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />

                    <span class="text-sm font-semibold ml-2">Retailers Scan</span>
                  </div>

                  <!-- SECONDARY BUTTON: MOVE TO CART -->
                  <div
                    class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                    @click="showTrend(item, index)"
                  >
                    <feather-icon icon="TrendingUpIcon" svgClasses="h-4 w-4" />

                    <span class="text-sm font-semibold ml-2">Show Trend</span>
                  </div>
                </div>
              </template>
            </item-grid-view>
          </div>
        </div>
      </template>
      <scroll-loader :loader-method="getStockInfo" :loader-enable="loadMore"></scroll-loader>

      <manage-stock
        :isSidebarActive="addNewDataSidebar"
        @closeSidebar="toggleDataSidebar"
        :data="sidebarData"
      />
    </div>
    <vs-popup
      background-color="rgba(255,255,255,.6)"
      class
      :title="'SKUs_with_filter_'+getFilterName+' @ '+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY')"
      :active.sync="exportListPop"
      v-if="exportListPop"
    >
      <ExportFilteredGrid :payload="payload"></ExportFilteredGrid>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
import ScrollLoader from "vue-scroll-loader";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

//you need to import the CSS manually (in case you want to override it)
import "vue-multiselect/dist/vue-multiselect.min.css";

import Explore from "./Explore.vue";
import Guide from "./Guide.vue";
import Visualizer from "./Visualizer.vue";
import ManageStock from "./ManageStock.vue";
import ExportFilteredGrid from "./ExportFilteredGrid.vue";

import appConfig from "@/../appConfig.js";
import { appCommons, appAnalyze } from "@/app/shared/services";
import { fetchTags, fetchArtefact, fetchArtefacts } from "../shared/services";

import { actionsTypes } from "../shared/state";

const ItemGridView = () => import("./ItemGridView.vue");
const ItemListView = () => import("./ItemListView.vue");
const ItemManageView = () => import("./ItemManageView.vue");

export default {
  props: {
    // artefact: { type: Object, required: true }
  },
  data() {
    return {
      showGrid: true,
      currentFilter: "exceptions",
      currentItemView: this.$route.params.view ? this.$route.params.view : "item-grid-view",
      queryParams: this.$route.query,
      isFilterSidebarActive: true,
      clickNotClose: true,
      windowWidth: window.innerWidth,

      colors: appConfig.colors,
      loadMore: true,
      callInProgress: false,
      stock: [],
      stats: [],
      stockStats: null,
      wrtprice: true,
      stockSearchQuery: "",
      debounce: null,
      error: null,
      exportListPop: false,
      filterName: '',

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},

      backgroundLoading: "primary",
      colorLoading: "#fff",

      payload: {
        tags: [],
        filters: [],
        dateRange: {
          startDate: "05/03/2019",
          endDate: "08/03/2019"
        },
        page: {
          size: 20,
          pos: 1
        },
        query: "",
        mode: "",
        type: "STOCK",
        res: {}
      },

      //MultiSelect Config
      multiselect: {
        exploreTags: [],
        tags: [],
        isLoading: false,
        selected: null,
        tagTypes: {
          S: "Store",
          M: "Manufacturer",
          B: "Brand",
          C: "Category",
          U: "Sku",
          G: "Sub Category",
          D: "Department",
          E: "Entity"
        }
        // options: ['list', 'of', 'options'],
      },

      filterType: 'overall',
      searchModes: [],
      searchTags: [
        {
          tag: "Product Name",
          code: "name",
          status: true
        },
        {
          tag: "Product Code",
          code: "code",
          status: true
        },
        {
          tag: "Brand",
          code: "brand",
          status: true
        },
        {
          tag: "Category",
          code: "cat",
          status: false
        },
        {
          tag: "Sub Category",
          code: "sub_cat",
          status: false
        },
        {
          tag: "Department",
          code: "dep",
          status: false
        },
        {
          tag: "Company",
          code: "company",
          status: false
        }
      ],      

    };
  },
  computed: {
    filteredStock() {
      let skus = this.stock.map(item => item[0]);
      return skus;
    },
    getBusinesses() {
      return this.priceShare.map(d => {
        return {tag: d.brand, type: 'E'}
      });
    },
    getFilterType() {
      return this.filterType;
    },
    samplePriceShare() {
      let samplePs = [];
      let priceShare = (this.stockStats && this.stockStats.trend) ? this.stockStats.trend : null;
      for(let ps of priceShare) {
        if(ps.productDistribute) {
          samplePs= ps.productDistribute
          break;
        }
      }
      return samplePs;
    },
    priceShare() {
      let priceShare = (this.stockStats && this.stockStats.trend) ? this.stockStats.trend : null;
      return priceShare;
    },
    deltaAll() {
      let all = (this.stockStats && this.stockStats.delta) ? this.stockStats.delta : null;
      return all;
    },
    deltaShare() {
      let share = (this.stockStats && this.stockStats.delta) ? this.stockStats.delta.share : null;
      if(share) {
        share.sort(function (x, y) {
          let xLabelParts = x.label.split('-')
          let yLabelParts = y.label.split('-')
          return isNaN(yLabelParts[0])  ? -1 : xLabelParts[0] - yLabelParts[0];
        });
      }
      
      return share;
    },
    deltaShareTranspose() {
      let label = this.deltaShare.map(d => d.label)
      let high = this.deltaShare.map(d => d.high)
      let low = this.deltaShare.map(d => d.low)
      let hamp = this.deltaShare.map(d => d.hamp)
      let lamp = this.deltaShare.map(d => d.lamp)

      let transposedData = {
        label: label,
        high: high,
        low: low,
        hamp: hamp,
        lamp: lamp
      }
      
      return transposedData;
    },
    getFilterName() {
      return this.filterType+'_by_'+(this.wrtprice ? 'average_market_price' : 'next_closest_price');
    },

    ...mapGetters({ artefact: "competer/artefact" })
  },
  methods: {
    // Multiselect specific methods
    limitText(count) {
      return `and ${count} other tags`;
    },
    queryTags(query) {
      this.multiselect.isLoading = true;
      // fetchTags()
      //   .then(data => {
      //     this.tempTags = data.data;
      //     this.multiselect.tags = this.filterAndSortTags();
      //     this.multiselect.isLoading = false;
      //   })
      //   .catch(error => {
      //     this.multiselect.isLoading = false;
      //     throw new Error(error);
      //   });

      this.tempTags = this.getBusinesses;
      this.multiselect.tags = this.filterAndSortTags();
      this.multiselect.isLoading = false;
    },
    clearAll() {
      this.multiselect.exploreTags = [];
    },
    bucketAndSortTags(etags) {
      let tagBucket = [];
      let i = 0;
      let len = etags.length;
      // S - STORE, M - MANUFACTURER, B - BRAND, C - CATEGORY, U - SKU, G - SUBCAT ( GROUP ), D - DEPT, E - ENTITY ( Competitors )
      let tagBuckets = {
        B: [],
        C: [],
        U: [],
        S: [],
        M: [],
        G: [],
        D: [],
        E: [],
        order: "SMBCUGDE"
      };

      for (; i < len; i++) {
        tagBuckets[etags[i].type].push(etags[i]);
      }

      for (let j = 0; j < tagBuckets.order.length; j++) {
        Array.prototype.push.apply(
          tagBucket,
          tagBuckets[tagBuckets.order.charAt(j)]
        );
      }

      return tagBucket;
    },
    flatTags(etags) {
      let i = 0;
      let len = etags.length;
      let flatTags = "";

      for (; i < len; i++) {
        flatTags = flatTags.concat(etags[i].tag + ", ");
      }

      return flatTags.slice(0, -2);
    },
    filterAndSortTags() {
      let filteredTags = this.tempTags;

      return filteredTags.sort(function(t1, t2) {
        var tA = t1.tag.toUpperCase();
        var tB = t2.tag.toUpperCase();
        if (tA < tB) {
          return -1;
        }
        if (tA > tB) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },
  
    refresh() {
      this.buildFilters();
      this.queryStock();
    },
    buildFilters() {
      this.searchModes = []
      if(this.multiselect.exploreTags.length > 0) {
        this.filterType = 'specific'
        let flatSelectedTags = this.multiselect.exploreTags.map(d => d.tag);

        let distribution = this.samplePriceShare
        for(let dist of distribution) {
          let mappedDist = [];
          for(let ps of this.priceShare) {
            if(flatSelectedTags.includes(ps.brand) && ps.productDistribute) { 
              mappedDist.push(ps.productDistribute.filter(d => d.label === dist.label)[0])
            }
          }

          let total = mappedDist && mappedDist.length === 1 ? mappedDist[0].count : -1
          let mode = {
            label: dist.label, 
            tag: dist.label, 
            code: dist.label.trim().replace(/ /g, "_").toLowerCase(), 
            desc: dist.label,
            mode: dist.label.trim().replace(/ /g, "_").toLowerCase(),
            status: this.searchModes.length === 0 ? true : false
          }

          mode[dist.label.trim().replace(/ /g, "_").toLowerCase()] = total;

          this.searchModes.push(mode);
        }
      } else {
        this.filterType = 'overall'
        let overallModes = [{
          label: "All",
          high: this.deltaAll.hpriced,
          low: this.deltaAll.lpriced,
          hamp: this.deltaAll.hpriced,
          lamp: this.deltaAll.lpriced,
          tag: "All",
          code: "all",
          desc: "All prices combined",
          icon: "icon-shuffle",
          status: true,
          mode: this.wrtprice ? 'hamp' : 'high'
        }]
        
        let otherModes = [];

        for(let d of this.deltaShare) {
          otherModes.push({
            ...d,
            tag: d.label,
            code: d.label.trim().replace('%', "").toLowerCase(),
            desc: "Price diff in given range",
            icon: "icon-zoom-in",
            status: false,
            mode: this.wrtprice ? 'hamp' : 'high'
          });
        }
        this.searchModes = [...overallModes, ...otherModes]
      }
    },
    initCompete() {
      // this.$store.dispatch('competer/'+ actionsTypes.FETCH_COMPETER_GUIDE, this.payload);
      // this.$store.dispatch('competer/'+ actionsTypes.FETCH_COMPETER_ARTEFACT, this.payload);
    },
    init() {
      if(this.filterType === 'overall' && this.queryParams && (this.queryParams.mode !== 'lamp' && this.queryParams.mode !== 'hamp')) {
        this.wrtprice = false
      }

      this.getStockOverview()
      .then(data => {
        this.stockStats = data.data;
        
        this.queryTags();
        let queryBiz = this.queryParams ? this.queryParams.biz : ''
        let queryTag = this.queryParams ? this.queryParams.tag : 'all'
        let queryMode = this.queryParams ? this.queryParams.mode : ''

        if(queryBiz) {
          this.multiselect.exploreTags = [];
          for(let b of this.getBusinesses) {
            if(b.tag.trim().replace(/ /g, "_").toLowerCase() === queryBiz.trim().replace(/ /g, "_").toLowerCase()) {
              this.multiselect.exploreTags.push(b);
            }
          }
        }
        
        this.buildFilters();
        

        if(queryTag) {
          for (var t of this.searchModes) {
            if(t.code === queryTag) {
              if(queryMode) {
                t.mode = queryMode;
              }
              t.status = true;
            } else {
              t.status = false;
            }
          }
        }
        this.callInProgress = false;
        this.queryStock();
      })
      .catch(error => {
      });
    },
    selectedTag(tag) {
      return tag.status ? "bg-primary-gradient text-white" : "";
    },
    selectedIcon(tag) {
      return tag.status ? "check_box" : "check_box_outline_blank";
    },
    applyFilter(tag) {
      tag.status = !tag.status;
      this.queryStock();
    },
    applyMode(tag, mode) {
      for (var t of this.searchModes) {
        t.status = false;
      }
      tag.status = true;
      if(mode) {
        tag.mode = mode;
      }
      this.queryStock();
    },
    selectedMode() {
      let tag = this.searchModes.filter(t => t.status);
      return this.currentItemView === "item-grid-view"
        ? "def"
        : tag && tag.length > 0
        ? tag[0].code
        : "all";
    },
    selectedFilter() {
      let filter = this.searchModes.filter(t => t.status);
      if(filter && filter.length > 0) {
        return filter[0];
      }
      return null;
    },
    getStat(tag, mode) {
      let tagCode = mode ? mode : tag.mode
      return tag[tagCode] ? tag[tagCode] : 0;
    },
    debounceQueryStock(event) {
      // this.stockSearchQuery = event
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.queryStock()
      }, 600)
    },
    queryStock() {
      this.loadMore = true;
      this.payload.page.pos = 1;
      this.stock = [];
      this.payload.query = this.stockSearchQuery.toLowerCase();
      this.payload.tags = this.bucketAndSortTags(this.multiselect.exploreTags);

      // if((this.stockSearchQuery && this.stockSearchQuery.length > 1) || (this.payload.tags && this.payload.tags.length > 0)) {
      //   this.getStockInfo('STOCKSEARCH');
      // } else if(!this.stockSearchQuery && (!this.payload.tags || (this.payload.tags && this.payload.tags.length < 1)) &&
      //             this.selectedMode() !== 'all') {
      //   this.getStockInfo('STOCK');
      // }

      if (
        !this.stockSearchQuery &&
        (!this.payload.tags ||
          (this.payload.tags && this.payload.tags.length < 1)) &&
        this.selectedMode() === "def"
      ) {
        this.getStockInfo("STOCK");
      } else {
        this.getStockInfo("STOCKSEARCH");
      }
    },
    getStockInfo(type) {
      if (!this.callInProgress) {
        this.callInProgress = true;

        this.payload.mode = this.selectedMode();
        if (type) {
          this.payload.type = type;
        }

        this.payload.filters = this.searchTags;
        this.payload.filterScope = this.selectedFilter();
        this.payload.filterRef = this.wrtprice ? 'AVG' : 'NCP';
        this.payload.filterType = this.filterType;
        

        fetchArtefacts(this.payload)
          .then(res => {
            let stockOnPage = res.data.skus.map(item =>
              item._source ? item._source : item[0]
            );

            this.stock = this.stock.concat(stockOnPage);
            this.stats = res.data.stats;

            // Stop scroll-loader
            if (res.data.skus.length < Number(this.payload.page.size)) {
              this.loadMore = false;
              this.payload.page.pos = 1;
            } else {
              this.payload.page.pos++;
            }
            this.callInProgress = false;
          })
          .catch(error => {
            this.callInProgress = false;
            this.payload.page.pos = 1;
            this.loadMore = false;
            throw new Error(error);
          });
      }
    },
    showTrend(item, index) {
      this.callInProgress = true;
      appAnalyze.pendoTrack("SKU Trend", {});
      this.$router.push("/competer/sku/" + item.code);
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      this.$store.dispatch("dataList/removeItem", id).catch(err => {
        console.error(err);
      });
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    changeView(selectedView) {
      this.currentItemView = selectedView;
      this.stockSearchQuery = "";
      this.multiselect.exploreTags = [];
      for (var t of this.searchModes) {
        if (t.code === "all") {
          t.status = true;
        } else {
          t.status = false;
        }
      }
      this.init();
    },

    getStockOverview() {
      let payload = {
        tags: [],
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        query: "",
        mode: "quantity",
        type: "DASH",
        res: {}
      }

      return fetchArtefact(payload)
        // .then(data => {
        //   this.stockStats = data.data;
        // })
        // .catch(error => {
        // });
    },

    getListForExport(type) {
      this.exportListPop = true;
    },


  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.init();
    this.initCompete();

    this.$store.watch(
      (state, getters) => getters["competer/artefact"],
      (newValue, oldValue) => {
        this.payload = newValue;
        this.init();
      }
    );
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  watch: {
    "$store.state.AppScopeTrack"(val) {
      this.init();
    }
  },
  components: {
    ItemGridView,
    ItemListView,
    ItemManageView,
    ManageStock,
    Explore,
    Guide,
    Visualizer,
    Multiselect,
    ExportFilteredGrid
  }
};
</script>

<style lang="scss" scoped>
#stock-view {
  .item-view-primary-action-btn {
    // color: #2c2c2c !important;
    // background-color: #f6f6f6;
    // min-width: 50%;
  }

  .item-view-secondary-action-btn {
    // min-width: 50%;
  }

  .knowledge-base-jumbotron-content {
    // background-image: url('/assets/images/pages/knowledge-base-cover.jpg');
    // background-size: cover;
  }
}
</style>
